/// <reference path="typings.d.ts"/>

import { DecimalPipe } from '@angular/common'
import {
  HttpHandlerFn,
  HttpRequest,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http'
import { enableProdMode, importProvidersFrom } from '@angular/core'
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { bootstrapApplication } from '@angular/platform-browser'
import { provideAnimations } from '@angular/platform-browser/animations'
import { DEV_OR_LOCALHOST, MAP } from '@bases/base.token'
import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '@core/constants/constant.data'
import { HttpInterceptor } from '@core/http.interceptor'
import {
  CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  customBearerTokenInterceptor,
  provideKeycloak,
} from 'keycloak-angular'
import Keycloak from 'keycloak-js'
import { provideMatomo, withRouter } from 'ngx-matomo-client'
import { BehaviorSubject } from 'rxjs'
import { AppComponent } from './app/app.component'
import { AppRoutingModule } from './app/app.routes'
import { environment } from './environments/environment'

// Hide logs (log and warn) in production
if (environment.production) {
  window.console.log = () => {}
  window.console.warn = () => {}
  enableProdMode()
}

function getDevOrLocalhost(): string {
  const isDevCondition = ['dev']
  const isLocalhostCondition = ['localhost']
  if (isDevCondition.some((url) => environment.apiUrl.toLowerCase().includes(url))) {
    return 'Development'
  } else if (isLocalhostCondition.some((url) => environment.apiUrl.toLowerCase().includes(url))) {
    return 'Localhost'
  } else {
    return 'Production'
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppRoutingModule),

    provideAnimations(),

    DecimalPipe,

    // Injection Tokens
    { provide: MAP, useValue: new BehaviorSubject('') },
    { provide: DEV_OR_LOCALHOST, useValue: new BehaviorSubject(getDevOrLocalhost()) },

    // Material default theme
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },

    provideHttpClient(withFetch()),
    // Interceptor for error message http request
    provideHttpClient(withInterceptors([HttpInterceptor])),

    // Matomo (cookies)
    provideMatomo(
      {
        trackerUrl: environment.matomoTrackerUrl,
        siteId: environment.matomoSiteId,
        requireConsent: 'tracking',
      },
      withRouter(),
    ),

    //Keycloak
    provideKeycloak({
      config: {
        url: KEYCLOAK_URL,
        realm: KEYCLOAK_REALM,
        clientId: KEYCLOAK_CLIENT_ID,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        checkLoginIframe: true,
        checkLoginIframeInterval: 30, // Check every 30 seconds
      },
    }),
    provideHttpClient(withInterceptors([customBearerTokenInterceptor])),
    {
      provide: CUSTOM_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [
        {
          shouldAddToken: async (
            req: HttpRequest<unknown>,
            _: HttpHandlerFn,
            _keycloak: Keycloak,
          ) => {
            const { method, url } = req
            const isGetRequest = 'GET' === method.toUpperCase()
            const acceptablePaths = ['/geoserver']
            const isAcceptablePathMatch = acceptablePaths.some((path) => url.includes(path))
            return !(isGetRequest && isAcceptablePathMatch)
          },
        },
      ],
    },
  ],
})
